<div class="ui-color-picker-field" [class.ui-color-picker-disabled]="disabled">
    <label *ngIf="label" class="ui-field-label">{{ label }}</label>

    <div class="ui-color-picker-input">
        <button
            type="button"
            class="ui-color-picker-swatch"
            [style.background-color]="colorValue"
            [disabled]="disabled"
            aria-label="Selecionar cor"
            (click)="openColorPicker()"
        ></button>

        <input
            type="text"
            class="ui-color-picker-text"
            [value]="textValue"
            [disabled]="disabled"
            autocomplete="off"
            spellcheck="false"
            [attr.aria-label]="label || 'Cor (hex, rgb ou rgba)'"
            placeholder="hex, rgb ou rgba"
            (input)="onTextInput($event)"
            (keydown.enter)="onTextEnter($event)"
            (blur)="onTextBlur()"
        />

        <input
            #nativeColorPicker
            type="color"
            class="ui-color-picker-native"
            [value]="hexColor"
            [disabled]="disabled"
            tabindex="-1"
            aria-hidden="true"
            (input)="onNativeColorInput($event)"
        />
    </div>

    <input
        type="range"
        class="ui-color-picker-alpha-slider"
        [style.background]="alphaGradient"
        [disabled]="disabled"
        [value]="alpha * 100"
        min="0"
        max="100"
        aria-label="Transparência da cor"
        (input)="onAlphaInput($event)"
    />
</div>
